import { gql } from 'graphql-request'

import { client } from '@/proxy/client'

import { useQuery } from '@/proxy/react-query'

import type { QueryOptions } from '@/resources/types'

import type { ActiveOrdersNanodropData } from './types'

import type { QueryClient } from '@/proxy/react-query'

export const ACTIVE_ORDERS_NANODROP = gql`
  query sellerActiveNanodrop {
    activeOrdersNanodrop {
      orderNumber
      sourceOrderNumber
      orderStatus
      receivedAt
      statusUpdateAt
      scheduledDeliveryAt
      methodOfPayment
      client {
        name
        document
        phone
      }
      delivery {
        address {
          zip
          number
          city
          street
          neighborhood
          state
          complement
          latitude
          longitude
        }
      }
      charging {
        totalAmount
        shippingFee
      }
      products {
        id
        name
        quantity
        price
      }
      statusHistory {
        date
        status
        reason
        courierName
        author
      }
    }
  }
`

export const ACTIVE_ORDERS_NANODROP_QUERY_KEY = 'useActiveOrdersNanodrop'

export const activeOrdersNanodropFullListQueryKey = [
  ACTIVE_ORDERS_NANODROP_QUERY_KEY,
]

export const useActiveOrdersNanodrop = (options: QueryOptions = {}) =>
  useQuery<ActiveOrdersNanodropData>({
    queryKey: [ACTIVE_ORDERS_NANODROP_QUERY_KEY],
    queryFn: ({ signal }) =>
      client.request<ActiveOrdersNanodropData>({
        document: ACTIVE_ORDERS_NANODROP,
        signal,
      }),
    ...options,
  })

export const invalidateActiveOrdersNanodropQuery = async ({
  queryClient,
}: {
  queryClient: QueryClient
}) => {
  await queryClient.invalidateQueries({
    queryKey: [ACTIVE_ORDERS_NANODROP_QUERY_KEY],
  })
}
